import {Label, TextMedium} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

interface DetailLabelProps {
  staticPartName: string
  componentType: string
  interventionDate: string
}

export const DetailLabel = ({
  staticPartName,
  componentType,
  interventionDate
}: DetailLabelProps) => {
  const {t} = useTranslation()

  return (
    <div>
      <Label
        title={t('staticParts.editReplacement.helperText')}
        inverted
        data-cy="static_part_detail_label"
      >
        <TextMedium>{`${staticPartName} | ${t(
          `staticParts.components.${componentType}`
        )} (${interventionDate})`}</TextMedium>
      </Label>
    </div>
  )
}
